import React from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'modules/App/components/ErrorPage/ErrorPage';

export default class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    pathname: PropTypes.string,
  };

  static getDerivedStateFromError() {
    // Обновить состояние с тем, чтобы следующий рендер показал запасной UI.
    return { hasError: true };
  }

  state = {
    hasError: false,
  };

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.pathname !== this.props.pathname) {
      this.resetErrorState();
    }
  }

  resetErrorState = () => {
    this.setState({ hasError: false });
  };

  // componentDidCatch(error, errorInfo) {
  // Можно также сохранить информацию об ошибке в соответствующую службу журнала ошибок

  // console.log(error, errorInfo);
  // logErrorToMyService(error, errorInfo);
  // }

  render() {
    if (this.state.hasError) {
      // Можно отрендерить запасной UI произвольного вида
      return <ErrorPage backPage={window.location.href} />;
    }

    return this.props.children;
  }
}
